import { GlobalState } from '../../actions';

export const portletSelector = (state: GlobalState) => state.portlet;

export const portletEntriesSelector = (name: string) => (state: GlobalState) => portletSelector(state).portlets[name];
